// 審査結果アコーディオン
import React, { useState } from 'react';
import RowTemplate from '../atoms/RowTemplate';
import Heading from '../molecules/Heading';
import ShelfInShelf from '../molecules/ShelfInShelf';
import TextArea from '../molecules/TextArea';

interface Props {
  review_approval_status_name: string;
  review_message: string;
  is_open?: boolean;
}

const ReceptionResult: React.FC<Props> = ({
  review_approval_status_name,
  review_message,
  is_open = false,
}) => {
  const [show_shelf, setShowShelf] = useState(is_open);
  const toggleShowShelf = () => setShowShelf(prev => !prev);

  return (
    <>
      <Heading size="m" label="審査結果" />
      <ShelfInShelf
        id="reception-result"
        is_open={show_shelf}
        handleClick={toggleShowShelf}
        label="借入申込結果"
      >
        <RowTemplate label="審査結果" content={review_approval_status_name} looks_inactive show />
        <TextArea
          id="reception-result-text"
          label="お客様へのお知らせ"
          value={review_message}
          handleChange={() => {}}
          name="reception-result-text"
          disabled={false}
          looks_inactive
        />
      </ShelfInShelf>
    </>
  );
};
export default ReceptionResult;
